import { render, staticRenderFns } from "./MainUI.vue?vue&type=template&id=97bd887a&scoped=true&"
import script from "./MainUI.vue?vue&type=script&lang=ts&"
export * from "./MainUI.vue?vue&type=script&lang=ts&"
import style0 from "./MainUI.vue?vue&type=style&index=0&id=97bd887a&prod&lang=scss&scoped=true&"
import style1 from "./MainUI.vue?vue&type=style&index=1&id=97bd887a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bd887a",
  null
  
)

export default component.exports